<template>
  <div
    class="plv-iar-lottery-widget"
    @click="clickPendant">
    <pendant
      v-show="visible"
      :icon-url="iconUrl"
      :time="leftTime"
      :tooltip="tooltip"
      :show-time-zero="true"
      :time-zero-text="iarTrans('lottery.inLottery')"
      :content="statusText[status]"
      :show-tooltip="showTooltip || (hideLeftTime > 0 && hideLeftTime <= 3)"
      @countdown="handleCountdown"
    />
  </div>
</template>

<script>
import lotteryMixin from '../lottery-mixin';
import Pendant from '../../../components/pendant/pendant.vue';
import defaultIconUrl from './imgs/widget.png';
import defaultEnIconUrl from './imgs/widget-en.png';

// 抽奖进行状态
const allLotteryStatus = {
  // 计时中
  timing: 'timing',
  // 抽奖中
  running: 'running',
  // 已结束
  over: 'over',
};

export default {
  mixins: [lotteryMixin],
  props: {
    lotterySdk: {
      type: Object,
      required: true
    },
    lotteryManualEndEnabled: {
      type: String,
      default: 'Y'
    }
  },
  data() {
    return {
      hideLeftTime: '',
      visible: false,
      leftTime: 0,
      getLeftTimeStatus: false,
      lotteryList: [],
      showTooltip: false,
      timer: null
    };
  },
  watch: {
    lotterySdk: {
      immediate: true,
      handler() {
        this.bindAppEvents();
      },
    },
    lotteryList: {
      handler(val) {
        this.$emit('update-lottery-list', val);
      },
      immediate: true
    }
  },
  components: { Pendant },
  computed: {
    lastLeftTime() {
      // 最后3秒展示提示
      return !this.status && this.hideLeftTime <= 3;
    },
    statusText() {
      return {
        running: this.iarTrans('lottery.inLottery'),
        over: this.iarTrans('lottery.lotteryEnd'),
      };
    },
    iconUrl() {
      return this._useLang === 'zh_CN' ? defaultIconUrl : defaultEnIconUrl;
    },
    tooltip() {
      if (this.hideLeftTime > 3) {
        return this.iarTrans('lottery.lotteryPendantTip1');
      } else if (this.hideLeftTime <= 3 && this.hideLeftTime >= 0) {
        return this.iarTrans('lottery.lotteryPendantTip2');
      }
      return '';
    },
    status() {
      const lotteryList = this.lotteryList;
      let status = '';
      console.info('update-lottery-list', JSON.stringify(lotteryList));
      for (const item of lotteryList) {
        // 判断手动结束抽奖超管是否为Y
        if (item.lotteryManualEndEnabled !== 'Y' && item.status === 'lottery') {
          status = allLotteryStatus.over;
          break;
        }
        if (item.status === 'lottery') {
          status = allLotteryStatus.running;
          break;
        } else if (item.status === 'over') {
          status = allLotteryStatus.over;
          break;
        } else if (item.status === 'wait') {
          status = '';
        }
      }
      this.$emit('change-status', status);
      return status;
    }
  },
  methods: {
    bindAppEvents() {
      const lotterySdk = this.lotterySdk;
      if (!lotterySdk) { return; }
      this.getLastLotteryList();
      lotterySdk
        .on(lotterySdk.events.DelayLotteryStart, this.handlerDelayLotteryStart)
        .on(lotterySdk.events.LotteryStart, this.handlerLotteryStart)
        .on(lotterySdk.events.LotteryEnd, this.handlerLotteryEnd)
        .on(lotterySdk.events.DelayLotteryOver, this.handlerDelayLotteryOver)
        .on(lotterySdk.events.DelayLotteryEnd, this.handlerDelayLotteryEnd);
    },
    async handlerDelayLotteryStart(data) {
      this.synchronizeLeftTime();
      await this.waitDelay();
      const index = this.lotteryList.findIndex(item => item.lotteryId === data.lotteryId);
      if (index === -1) {
        this.lotteryList.push({ lotteryId: data.lotteryId, status: 'wait', lotteryManualEndEnabled: this.lotteryManualEndEnabled });
      }
      const { manualEndEnabledAndLottery } = this.checkLotteryList(this.lotteryList);
      if (manualEndEnabledAndLottery) {
        this.changeVisible(false);
      } else {
        this.changeVisible(true);
      }
    },
    checkLotteryList(lotteryList) {
      // 判断当手动结束抽奖为N，且抽奖状态为lottery时，不显示挂件。
      let manualEndEnabledAndLottery;
      // 当列表有wait，获取倒计时
      let fetchLeftTime = false;
      for (let i = 0; i < lotteryList.length; i++) {
        if (lotteryList[i].lotteryManualEndEnabled !== 'Y' && lotteryList[i].status === 'lottery') {
          manualEndEnabledAndLottery = lotteryList[i];
        }
        if (lotteryList[i].status === 'wait') {
          fetchLeftTime = true;
        }
      }

      return {
        manualEndEnabledAndLottery,
        fetchLeftTime,
      };
    },

    // eslint-disable-next-line sonarjs/cognitive-complexity
    async getLastLotteryList() {
      try {
        const res = await this.lotterySdk.getLastLotteryList();
        if (res.code === 200) {
          const lotteryList = res.data.lotterys;

          const { manualEndEnabledAndLottery, fetchLeftTime } = this.checkLotteryList(lotteryList);

          if (fetchLeftTime) this.synchronizeLeftTime();
          // 画面同步，延迟执行逻辑
          await this.waitDelay();
          this.lotteryList = lotteryList;
          if (manualEndEnabledAndLottery) {
            this.changeVisible(false);
          } else {
            this.changeVisible(lotteryList.length > 0);
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async handlerLotteryStart(data) {
      await this.waitDelay();
      const index = this.lotteryList.findIndex(item => item.lotteryId === data.lotteryId);
      if (index > -1) {
        this.lotteryList[index].status = 'lottery';
      }
    },
    handlerDelayLotteryOver() {},
    async handlerDelayLotteryEnd(data) {
      this.synchronizeLeftTime();
      await this.waitDelay();
      const index = this.lotteryList.findIndex(item => item.lotteryId === data.lotteryId);
      if (index > -1) {
        this.lotteryList.splice(index, 1);
      }
      this.changeVisible(this.lotteryList.length > 0);
    },
    async handlerLotteryEnd(data) {
      await this.waitDelay();
      const index = this.lotteryList.findIndex(item => item.lotteryId === data.lotteryId);
      if (index > -1) {
        this.lotteryList[index].status = 'over';
      }
    },

    async changeVisible(val) {
      this.visible = val;
      this.$emit('is-show-changed', val);
    },

    clickPendant() {
      if (this.status === '') {
        this.showTooltip = true;
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.showTooltip = false;
          this.timer = null;
        }, 3000);
      }
      if (!this.status) return;
      this.$emit('show-lottery', this.status);
    },

    // 10s同步一次时间, wait 是否跳过 延迟时间
    async synchronizeLeftTime(wait = true) {
      let data;
      if (this.getLeftTimeStatus) return;
      try {
        this.getLeftTimeStatus = true;
        data = await this.lotterySdk.getLeftTime();
      } catch (e) {
        console.warn(e);
      }
      this.getLeftTimeStatus = false;
      if (data) {
        if (wait) {
          await this.waitDelay();
        }
        this.leftTime = data.time;
        this.$emit('update-left-time', data.time);
        if (this.leftTime === 0) return;
        if (this.timer) return;
        // 10s同步一次定时
        this.timer = setTimeout(() => {
          this.timer = null;
          this.synchronizeLeftTime();
        }, 10000);
      }
    },
    handleCountdown(time) {
      this.hideLeftTime = time;
    },
  }
};
</script>

<style lang="scss">
.plv-iar-lottery-widget {
  .plv-iar-pendant__tooltip {
    color: #fff;
    border-color: #FD7232;
  }
  .plv-iar-pendant__tooltip--left {
    background: linear-gradient(231deg, #FF9D4D 0%, #F65F49 100%);
    &::before {
      border-left-color: #FD7232;
    }
    &::after {
      border-left-color: #FF9D4D;
    }
  }
  .plv-iar-pendant__tooltip--right {
    background: linear-gradient(231deg, #F65F49 0%, #FF9D4D 100%);
    &::before {
      border-right-color: #FD7232;
    }
    &::after {
      border-right-color: #FF9D4D;
    }
  }
  .plv-iar-pendant__countdown {
    color: rgba(255, 255, 255, 0.8);
  }
}
</style>
